import { c as _c } from "react/compiler-runtime";
import { IconArchive, IconArrowRight, IconConfetti } from "@tabler/icons-react";
import Link from "next/link";
import { useRouter } from "@/hooks/use-router";
import { Button } from "@domainstack/ui/button";
import { Icon } from "@domainstack/ui/icon";
interface NotificationEmptyStateProps {
  variant: "inbox" | "archive";
  onClosePopover?: () => void;
}
export function NotificationEmptyState(t0) {
  const $ = _c(17);
  const {
    variant,
    onClosePopover
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== variant) {
    t1 = <Icon className="mb-4">{variant === "inbox" ? <IconConfetti /> : <IconArchive />}</Icon>;
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = variant === "inbox" ? "All caught up!" : "Nothing archived yet";
  let t3;
  if ($[2] !== t2) {
    t3 = <p className="text-sm text-foreground/80">{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = variant === "inbox" ? "No unread notifications" : "Nothing to see here (yet\u2026)";
  let t5;
  if ($[4] !== t4) {
    t5 = <p className="mt-1 text-[13px] text-muted-foreground/80">{t4}</p>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onClosePopover || $[7] !== router) {
    t6 = e => {
      e.preventDefault();
      router.push("/dashboard");
      onClosePopover?.();
    };
    $[6] = onClosePopover;
    $[7] = router;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link href="/dashboard">Go to dashboard<IconArrowRight className="size-3" /></Link>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <Button variant="link" className="mt-5 text-[13px]" onClick={t6} nativeButton={false} aria-label="Go to dashboard" render={t7} />;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5 || $[15] !== t8) {
    t9 = <div className="flex flex-col items-center justify-center p-10 text-center">{t1}{t3}{t5}{t8}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}